import { useEffect, useMemo } from "react";
import { CTAButton } from "../components/ui-regera/CTAButton";
import { Frame, Head } from "../components/spec/Frame";
import { INDUSTRY_PAGE } from "../data/content";
import { useIndustries } from "../lib/hooks";
import { groupBy } from "../data/catalog";

const List = ({ items }) => (
  <ul className="mt-5 divide-y divide-white/10 border-y border-white/10">
    {items.map((x) => (
      <li key={x.id || x.name} className="py-3 text-white/85 text-base lg:text-lg flex items-center gap-3">
        <span className="h-1.5 w-1.5 bg-[#e60000] shrink-0" />
        {x.name}
      </li>
    ))}
  </ul>
);

export default function Industries() {
  useEffect(() => {
    document.title = "Industries — REGERA";
  }, []);
  const industries = useIndustries();
  const { coverage: c, emerging: e } = INDUSTRY_PAGE;
  const coverageGroups = useMemo(() => groupBy(industries.filter((x) => x.section !== "emerging")), [industries]);
  const emerging = useMemo(() => industries.filter((x) => x.section === "emerging"), [industries]);
  return (
    <div data-testid="industries-page">
      <Frame id="industries-coverage" first>
        <Head as="h1" fit overline={c.overline} title={c.title} body={c.body} />
        <div className="mt-10 grid lg:grid-cols-2 gap-10">
          {coverageGroups.map((g) => (
            <div key={g.key} data-pg-item data-testid="industry-group">
              <h3 className="font-display text-xl lg:text-2xl font-bold text-white rg-fs-h3">{g.title}</h3>
              <List items={g.items} />
            </div>
          ))}
        </div>
      </Frame>
      <Frame id="industries-emerging">
        <Head overline={e.overline} title={emerging[0]?.group || e.title} fit />
        {emerging.length > 0 && (
          <div className="rg-gap mt-8 grid sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
            {emerging.map((x, i) => {
              const last = i === emerging.length - 1;
              // the last tile widens to close the row, so no empty cell is left in the grid
              const span = `${last && emerging.length % 2 ? "sm:col-span-2" : ""} ${last && emerging.length % 4 === 3 ? "lg:col-span-2" : ""}`;
              return (
                <div key={x.id || x.name} className={`bg-[#0a0a0a] p-5 rg-pad text-white/90 text-base lg:text-lg rg-fs-item border-r border-b border-white/10 ${span}`}>{x.name}</div>
              );
            })}
          </div>
        )}
        <div className="rg-gap mt-10 flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-12">
          <p className="font-display text-xl lg:text-2xl font-bold text-white leading-snug max-w-2xl border-l-2 border-[#e60000] pl-6 rg-fs-sub">{e.closing}</p>
          <CTAButton to="/contact#enquiry" testId="industries-engage-cta" className="shrink-0">Discuss Your Requirements</CTAButton>
        </div>
      </Frame>
    </div>
  );
}
